<script lang="ts">
	// Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';

	// Helpers
	import { real_id } from 'src/helpers/interface_helpers';

	// Components
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';

	// Types
	import type { Device } from 'src/types/Device.ts';
	import ControlSwitch from 'src/components/Controls/Single/ControlSwitch.svelte';
	import { createGen1StatusLabels, getGen1DeviceStatuses } from '../../../Gen1/gen1-main-helpers';
	import { devices_config } from '@devices/index';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';

	export let device: Device;

	$: id = $sidePanelStateCombined?.id;
	$: deviceData = device || $devices[id];
	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: deviceConfig = devices_config?.[deviceData?.type];

	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
	>
		<DeviceLabelList {labelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		<ControlSwitch {device} {status} {settings} isWide />
	</div>
</DeviceViewStateWrapper>
